import { getLoungeDetail } from 'services';
import { getAgentId } from '@/utils/getValue';
import { Toast } from 'antd-mobile';
export default {
  namespace: 'lounge',
  state: {
    loungeMsg: {},
  },
  effects: {
    *queryLoungeDetail({ payload, callback }, { call, put }) {
      try {
        const agentId = getAgentId();
        if (agentId) payload.agentId = agentId;
        const response = yield call(getLoungeDetail, payload);
        const { state, data, note } = response.data;
        const isOk = state === '11';
        const loungeMsg = data || {};
        yield put({
          type: 'setData',
          payload: {
            loungeMsg: isOk ? loungeMsg : {},
          },
        });
        if (!isOk) {
          Toast.show(note, 0);
        }
        callback && callback();
      } catch (error) {
        console.log('error---', error);
      }
    },
  },
  reducers: {
    setData(state, { payload }) {
      return {
        ...state,
        ...payload,
      };
    },
  },
};
